<template>
  <!-- 账号管理 -->
  <div class="containerbox serverContent">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          v-if="hasPermiss('admin:user_account:addAccount')"
          class="itemBtn btnColor glo_bgcMainColor"
          @click="addServe()"
          >新建</el-button
        >
        <el-button
          v-if="hasPermiss('admin:user_account:startAccount')"
          class="itemBtn btnColor"
          @click="qiYong()"
          >批量启用</el-button
        >
        <el-button
          v-if="hasPermiss('admin:user_account:stopAccount')"
          class="itemBtn btnColor"
          @click="jinYong()"
          >批量禁用</el-button
        >
        <el-button
          v-if="hasPermiss('admin:user_account:delAccount')"
          class="itemBtn btnColor"
          @click="delBtns()"
          >批量删除</el-button
        >
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="hasPermiss('aaaaa')" command="dtdc"
              >导出</el-dropdown-item
            >
            <el-dropdown-item v-if="hasPermiss('aaaaa')" command="bgsz"
              >表格设置</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-button class="itemBtn btnColor" @click="DelServe()">删除</el-button> -->
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        :showMoreBtns="false"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <el-form-item class="queryItems" label="姓名:">
          <el-input
            clearable
            v-model="queryData.name"
            placeholder="请输入"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="部门:">
          <el-select
            filterable
            clearable
            v-model="queryData.deptId"
            placeholder="请选择"
            remote
            :loading="false"
            :remote-method="getDeptList"
            @change="changeDep"
          >
            <el-option
              v-for="(item, index) in deptNameList"
              :key="index"
              :label="item.departmentName"
              :value="item.deptId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格:height="tableHeigth" -->
    <div class="glo_Table" ref="tableWrapper">
      <el-table
        ref="mytable"
        :data="tableData"
        :height="tableHeigth"
        :row-class-name="tableRowClassName"
        highlight-current-row
        @row-click="rowclick"
        :header-cell-style="{ background: '#f0f0f0' }"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          type="selection"
          width="60"
        ></el-table-column>

        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <my-table-column
            v-if="item.field == 'userStatusShow'"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                style="color: #f00"
                v-if="scope.row.userStatus != 'zheng_chang:user_status'"
              >
                {{ scope.row.userStatusShow }}
              </div>
              <div v-else>{{ scope.row.userStatusShow }}</div>
            </template>
          </my-table-column>
          <my-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></my-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="330px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                v-if="hasPermiss('admin:user_account:udpateAccount')"
                class="rbtns"
                @click.stop="editorServe(scope.row.userId)"
                >编辑</el-button
              >
              <el-button
                v-if="hasPermiss('admin:user_account:startAccount')"
                class="rbtns"
                @click.stop="qiYong(scope.row.userId)"
                >启用</el-button
              >
              <el-button
                v-if="hasPermiss('admin:user_account:stopAccount')"
                class="rbtns"
                @click.stop="jinYong(scope.row.userId)"
                >禁用</el-button
              >
              <el-button
                v-if="hasPermiss('admin:user_account:savaUserPermission')"
                class="rbtns"
                @click.stop="AssignMent(scope.row)"
                >分配权限</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="hasPermiss('admin:user_account:updatePassword')"
                    command="a"
                    >修改密码</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="hasPermiss('admin:user_account:delAccount')"
                    command="b"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页组件 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :sizeList="sizeList"
      :size="pageTotal"
      class="serverPage"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <!-- 新建弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog"
          class="diaForm"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item class="dialogFormItems" prop="name" label="姓名:">
            <el-input v-model="dialogForm.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="username" label="账号:">
            <el-input
              v-model="dialogForm.username"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="dialogType == 'add'"
            class="dialogFormItems"
            prop="password"
            label="密码:"
          >
            <el-input
              v-model="dialogForm.password"
              placeholder="请输入(6-50位)"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="roleIds" label="角色:">
            <el-select
              filterable
              clearable
              multiple
              collapse-tags
              v-model="dialogForm.roleIds"
              placeholder="请选择"
              @change="changeTypeName"
            >
              <el-option
                v-for="(item, index) in roleLists"
                :key="index"
                :label="item.roleName"
                :value="item.roleId + ''"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item class="dialogFormItems" prop="bbb" label="所在部门:">
            <el-select
              filterable
              clearable
              v-model="dialogForm.roleIds"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in allDepLists"
                :key="index"
                :label="item.departmentName"
                :value="item.roleId"
              ></el-option>
            </el-select>
          </el-form-item>-->

          <!-- <el-form-item
            class="dialogFormItems"
            prop="documentId"
            label="使用对象类型:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.documentId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in userTypeList"
                :key="item.statusVal"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            class="dialogFormItems"
            prop="employeeId"
            label="使用对象:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.employeeId"
              placeholder="请选择"
              remote
              :loading="false"
              :remote-method="getEmployee"
              @change="changeemployee"
            >
              <el-option
                v-for="(item, index) in employeeList"
                :key="index"
                :label="item.employeeName"
                :value="item.employeeId"
              ></el-option>
            </el-select>
          </el-form-item>-->

          <el-form-item class="dialogFormItems" prop="userStatus" label="状态:">
            <el-select
              filterable
              clearable
              v-model="dialogForm.userStatus"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in StatusValList"
                :key="index"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>

          <template v-for="(item, idx) in dialogForm.objectVos">
            <div style="display: flex; width: 100%" :key="idx">
              <el-form-item
                style="width: 63.5%"
                class="dialogFormItems"
                :label="'使用对象' + (idx + 1) + ':'"
              >
                <div class="multipleSelect">
                  <el-select
                    filterable
                    clearable
                    v-model="dialogForm.objectVos[idx].userType"
                    placeholder="请选择"
                    @change="changeObjestStatus($event, idx)"
                  >
                    <el-option
                      v-for="item2 in userTypeList"
                      :key="item2.statusVal"
                      :label="item2.showName"
                      :value="item2.statusVal"
                    ></el-option>
                  </el-select>
                  <el-select
                    filterable
                    clearable
                    v-model="dialogForm.objectVos[idx].UserName"
                    placeholder="请选择"
                    remote
                    :remote-method="(val) => getObjectUserDownList(val, idx)"
                    @change="changeobjectName($event, idx)"
                    @focus="focusObjectname(idx)"
                  >
                    <el-option
                      v-for="(item3, index3) in dialogForm.objectVos[idx]
                        .CustomerLists"
                      :key="index3"
                      :label="item3.name"
                      :value="item3.name"
                    ></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <div class="glo_btnList_left" v-if="idx == 0">
                <el-button
                  class="itemBtn btnColor"
                  style="padding: 10px; margin-right: 10px"
                  @click="addObjs()"
                  >添加</el-button
                >
              </div>
              <div class="glo_btnList_left">
                <el-button
                  class="itemBtn btnColor"
                  style="padding: 10px"
                  @click="delObjs(idx)"
                  >移除</el-button
                >
              </div>
            </div>
          </template>
          <el-form-item label="业务查看范围:" class="dialogFormItems">
            <!-- <el-select
              v-model="dialogForm.seeRangeDeptIds"
              filterable
              multiple
              collapse-tags
              placeholder="请选择"
              clearable=""
            >
              <el-option
                v-for="(item, index) in storage_down_list"
                :key="index"
                :label="item.deptName"
                :value="Number(item.deptId)"
              />
            </el-select> -->
            <dept-tree v-model="dialogForm.seeRangeDeptIds" multiple i-need-all></dept-tree>
          </el-form-item>
          <el-form-item label="所属网点:" class="dialogFormItems">
            <!-- <el-select
              v-model="dialogForm.deptId"
              filterable
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="(item, index) in storage_down_list"
                :key="index"
                :label="item.deptName"
                :value="String(item.deptId)"
              />
            </el-select> -->
            <dept-tree v-model="dialogForm.deptId" :multiple="false" check-strictly i-need-all></dept-tree>
          </el-form-item>
          <el-form-item label="网点管理范围:" class="dialogFormItems">
            <!-- <el-select
              v-model="dialogForm.manageRangedeptIds"
              filterable
              multiple
              collapse-tags
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="(item, index) in storage_down_list"
                :key="index"
                :label="item.deptName"
                :value="Number(item.deptId)"
              />
            </el-select> -->
            <dept-tree v-model="dialogForm.manageRangedeptIds" multiple i-need-all></dept-tree>
          </el-form-item>
          <el-form-item
            style="width: 97%; margin-right: 3%"
            class="dislogFormTextarea"
            prop="remarks"
            label="备注:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="bindPhone"
            label="绑定手机:"
          >
            <el-input
              v-model="dialogForm.bindPhone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="bindMail"
            label="绑定邮箱:"
          >
            <el-input
              v-model="dialogForm.bindMail"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item
            v-if="dialogType == 'edit'"
            class="dialogFormItems"
            prop="aaa"
            label="绑定微信:"
          >
            <el-input
              v-model="dialogForm.aaa"
              placeholder="自动带出"
              disabled
            ></el-input>
          </el-form-item>-->
          <el-form-item
            v-if="dialogType == 'edit'"
            class="dialogFormItems"
            label="新建人:"
          >
            <el-input
              v-model="dialogForm.createUserName"
              placeholder="自动带出"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="dialogType == 'edit'"
            class="dialogFormItems"
            label="新建时间:"
          >
            <el-input
              v-model="dialogForm.createTime"
              placeholder="自动带出"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="dialogType == 'edit'"
            class="dialogFormItems"
            label="修改人:"
          >
            <el-input
              v-model="dialogForm.updateUserName"
              placeholder="自动带出"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="dialogType == 'edit'"
            class="dialogFormItems"
            label="修改时间:"
          >
            <el-input
              v-model="dialogForm.updateTime"
              placeholder="自动带出"
              disabled
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 修改密码 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogForm2"
          :model="dialogForm2"
          label-width="100px"
          :rules="rulesForm2"
        >
          <el-form-item
            class="dialogFormItems"
            style="margin: 70px auto"
            prop="newPasswpord"
            label="新密码:"
          >
            <el-input
              v-model="dialogForm2.newPasswpord"
              placeholder="请输入密码(6-50位)"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form
          :model="queryData"
          class="glo_form hasMoreParam"
          label-position="left"
        >
          <el-form-item class="queryItems" label="姓名:">
            <el-input
              clearable
              v-model="queryData.name"
              placeholder="请输入"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
          <el-form-item class="queryItems" label="部门:">
            <el-select
              filterable
              clearable
              v-model="queryData.deptId"
              placeholder="请选择"
              remote
              :loading="false"
              :remote-method="getDeptList"
              @change="changeDep"
            >
              <el-option
                v-for="(item, index) in deptNameList"
                :key="index"
                :label="item.departmentName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>
  </div>
</template>

<script>
import paging from "@/components/pagings.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
import DeptTree from'@/components/DeptTree.vue'
import MyTableColumn from '@/components/table/TableColumn.vue'
export default {
  mixins: [exportjs],
  inject: ["reload"],
  components: {
    queryBtns,
    myDialog,
    paging,
    uploadimgs,
    sorttable,
    DeptTree,
    MyTableColumn
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "账号管理", //导出时默认文件名
        apiName: "/admin/v3/tms/account/getAccountList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageStart: 1, //页码
      pageTotal: this.$COMMON.pageTotals, //一页几条,
      pageCount: 0, //总条数
      sizeList: [10, 20, 50, 100, 200],
      tableData: [], //表格数据
      tableHeigth: "75vh",
      selectTableData: [],

      queryData: { name: "", deptId: "" },
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogType: "add",
      dialogTitle: "",
      diaWidth: "50%",
      dialogForm: {
        // 弹窗表单数据
        userStatus: "zheng_chang:user_status",
        bindMail: "",
        deptId: "",
        seeRangeDeptIds: [],
        manageRangedeptIds: [],
        bindPhone: "",
        employeeId: "",
        name: "",
        password: "",
        remarks: "",
        username: "",
        roleIds: [],
        objectVos: [
          {
            documentId: "",
            UserName: "",
            CustomerLists: [],
            operationType: "ADD",
          },
        ],
      },
      rulesForm: {
        name: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        password: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        roleIds: [
          {
            validator: (rule, value, callback) => {
              if (!this.dialogForm.roleIds) {
                callback(new Error("请选择"));
              }
              if(this.dialogForm.roleIds.length == 0){
                callback(new Error("请选择"));
              }
              callback();
            },
            trigger: ["blur", "change"]
          },
        ],
        userStatus: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        username: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      isShowDialog2: false,
      dialogTitle2: "修改密码",
      diaWidth2: "30%",
      dialogForm2: {
        // 弹窗表单数据
        newPasswpord: "",
        userId: "",
      },
      rulesForm2: {
        newPasswpord: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      // upLoadUrl: this.$COMMON.uploadUrl,
      fileNameLists: [],

      // 默认表头
      tabelHeadeTitle: [
        {
          name: "用户姓名",
          field: "name",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "账号",
          field: "username",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "角色",
          field: "roleName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "使用对象类型",
          field: "userType",
          width: "160",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "使用人",
          field: "documentName",
          width: "160",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "所在部门",
          field: "deptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "是否禁用",
          field: "userStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "新建人",
          field: "createUserName",
          width: "120",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "新建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "修改人",
          field: "updateUserName",
          width: "120",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "修改时间",
          field: "updateTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "注销时间",
          field: "writeOffTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据

      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "AccountManagement", //  页面标识
      sortName: "综合查询模板", //  排序名

      roleLists: [],
      allDepLists: [],
      employeeList: [],
      deptNameList: [],
      StatusValList: [],
      userTypeList: [],
      DELObjsList: [],
      storage_down_list: [],
      all_dept_storage_down_list: [],
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }

    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
  },
  mounted() {
    this.getData();
    this.getDeptList();
    this.getUserTypeList();
    this.GetDept();
  },
  activated() {},
  watch: {},
  methods: {
    // 获取业务网点（组织架构列表）
    GetDept() {
      this.$API
        .runPageReport({
          number: "storage_down_list",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.storage_down_list = res.data.result.datas.data || [];
        });
      this.$API
        .runPageReport({
          number: "all_dept_storage_down_list",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.all_dept_storage_down_list = res.data.result.datas.data || [];
        });
    },
    addObjs() {
      this.dialogForm.objectVos.push({
        documentId: "",
        UserName: "",
        CustomerLists: [],
        operationType: "ADD",
      });
    },
    delObjs(idx) {
      this.$confirm("是否移除该使用对象?", "提示:")
        .then(() => {
          let arrs = JSON.parse(
            JSON.stringify(this.dialogForm.objectVos || [])
          );
          if (arrs[idx].operationType != "ADD") {
            arrs[idx].operationType = "DEL";
            this.DELObjsList.push(arrs[idx]);
          }
          arrs.splice(idx, 1);
          this.dialogForm.objectVos = arrs || [];
          if (this.dialogForm.objectVos.length == 0) {
            this.dialogForm.objectVos.push({
              documentId: "",
              UserName: "",
              CustomerLists: [],
              operationType: "ADD",
            });
          }
        })
        .catch(() => {});
    },
    // 获取对象类型
    getUserTypeList() {
      this.$TOOLS
        .getStatusValList("user_type_info_key_v1.user_type")
        .then((res) => {
          let userTypeList = res || [];
          let newArrays = [];
          // item.statusVal === "customer:object_status" ||
          userTypeList.forEach((item) => {
            if (
              item.statusVal === "employee:user_type" ||
              item.statusVal === "driver:user_type" ||
              item.statusVal === "customer:user_type" ||
              item.statusVal === "carrier:user_type"
            ) {
              newArrays.push(item);
            }
          });
          this.userTypeList = newArrays;
        });
    },
    // 获取账号对象的下拉列表
    getAccountObjectDownList(e, name, idx) {
      let index = idx || 0;
      this.$API
        .getAccountObjectDownList({
          key: e,
          name: name,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let datas = res.data.result.data || [];
          // this.dialogForm.objectVos[index].CustomerLists = datas;
          this.$set(this.dialogForm.objectVos[index], "CustomerLists", datas);
        });
    },
    // 选择对象类型
    changeObjestStatus(e, idx) {
      this.dialogForm.objectVos[idx].CustomerLists = [];
      this.dialogForm.objectVos[idx].UserName = "";
      if (e) {
        let userTypeList = this.dialogForm.objectVos.map((item) => {
          return item.userType;
        });
        let num = 0;
        userTypeList.forEach((item2) => {
          if (item2 == e) {
            num++;
          }
        });
        if (num > 1) {
          this.$message.error("已存在该对象类型");
          this.dialogForm.objectVos[idx].userType = "";
          return false;
        }
        this.getAccountObjectDownList(e, "", idx);
      }
    },
    focusObjectname(idx) {
      if (!this.dialogForm.objectVos[idx].userType) {
        this.$message.error("请先选择对象类型");
        return false;
      }

      this.getAccountObjectDownList(
        this.dialogForm.objectVos[idx].userType,
        "",
        idx
      );
    },
    // 选择具体某个对象
    changeobjectName(e, idx) {
      if (e) {
        this.dialogForm.objectVos[idx].CustomerLists.forEach((item) => {
          if (item.name == e) {
            this.dialogForm.objectVos[idx].documentId = item.documentId + "";
            this.dialogForm.objectVos[idx].documentName = item.name;
          }
        });
        this.getAccountObjectDownList(
          this.dialogForm.objectVos[idx].userType,
          "",
          idx
        );
      } else {
        this.getAccountObjectDownList(
          this.dialogForm.objectVos[idx].userType,
          e || "",
          idx
        );
      }
      this.$forceUpdate(); //强制更新
    },
    getObjectUserDownList(e, idx) {
      this.getAccountObjectDownList(
        this.dialogForm.objectVos[idx].userType,
        e || "",
        idx
      );
    },
    // 禁用
    jinYong(id) {
      let ids = [];
      if (id) {
        //左边单个操作
        ids.push(id);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要禁用的账号");
          return false;
        }
        ids = this.selectTableData.map((item) => {
          return item.userId;
        });
      }

      this.$confirm("是否禁用所选账号?", "提示:").then((res) => {
        this.$API.wtl_stopAccount({ userIds: ids }).then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.getData();
        });
      });
    },
    // 启用
    qiYong(id) {
      let ids = [];
      if (id) {
        //左边单个操作
        ids.push(id);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要启用的账号");
          return false;
        }
        ids = this.selectTableData.map((item) => {
          return item.userId;
        });
      }

      this.$confirm("是否启用所选账号?", "提示:").then((res) => {
        this.$API.wtl_startAccount({ userIds: ids }).then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.getData();
        });
      });
    },
    // 删除
    delBtns(id) {
      let ids = [];
      if (id) {
        //左边单个操作
        ids.push(id);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要删除的账号");
          return false;
        }
        ids = this.selectTableData.map((item) => {
          return item.userId;
        });
      }

      this.$confirm("是否删除所选账号?", "提示:").then((res) => {
        this.$API.wtl_delAccount({ userIds: ids }).then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.getData();
        });
      });
    },
    // 获取员工列表(下拉,远程搜索)
    getDeptList(deptName) {
      this.$API
        .wtl_getDeptList({
          deptName: deptName || "",
          pageStart: 1,
          pageTotal: 100,
        })
        .then((res) => {
          this.deptNameList = res.data.result.data || [];
        });
    },
    // 获取员工列表(下拉,远程搜索)
    getEmployee(employeeName) {
      this.$API
        .wtl_getEmployeeList({
          employeeName: employeeName || "",
          pageStart: 1,
          pageTotal: 100,
        })
        .then((res) => {
          this.employeeList = res.data.result.data || [];
        });
    },
    // 获取角色下拉列表
    getRoleList(name) {
      let that = this;
      let param = {
        pageStart: 1,
        pageTotal: 100,
        roleName: name,
      };
      this.$API.wtl_roleList(param).then((res) => {
        that.roleLists = res.data.result.data || [];
      });
    },
    //部门变化触发
    changeDep(e) {
      if (!e) {
        this.getDeptList();
      }
      this.queryBtn_ok();
    },
    //角色变化触发
    changeTypeName(e) {
      if (!e) {
        this.getRoleList();
      }
      // 使用v-model绑定 el-select多选时要用 this.$forceUpdate() 强制重新渲染
      this.$forceUpdate();
    },
    //员工清空时触发
    changeemployee(e) {
      if (!e) {
        this.getEmployee();
      }
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      // a==修改密码
      if (type === "a") {
        this.isShowDialog2 = true;
        this.dialogForm2.userId = val.userId;
      }
      // d==删除
      if (type === "b") {
        this.delBtns(val.userId);
      }
    },

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dtdc") {
        // 导出
        // this.exportBtn();
        this.isShowDialog_dc = true;
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = { name: "", deptId: "" };
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    // 删除
    DelServe() {
      if (this.selectTableData.length < 1) {
        this.$message({
          message: "请至少勾选一条数据",
          type: "warning",
        });
        return false;
      }

      this.$confirm("该操作将永久删除该文章,请谨慎操作!", "提示:")
        .then((res) => {
          let ids = [];
          this.selectTableData.forEach((item) => {
            ids.push(item.articleId);
          });
          let param = {
            articleId: ids,
          };
          param.sign = "";
          this.$API.deleteArticle(param).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch(() => {});
    },
    aaaaaa() {},
    // 分配权限
    AssignMent(data) {
      this.$router.push({
        path: "/SystemSetting/PermissionAssignmentUser",
        query: {
          nid: data.userId,
          userName: data.username,
        },
      });
    },

    // 获取账号状态
    getStatusValLists() {
      this.$TOOLS.getStatusValList("user_v1.user_status").then((res) => {
        let arr = res || [];
        let arr2 = [];
        arr.forEach((item) => {
          if (
            item.statusVal == "zheng_chang:user_status" ||
            item.statusVal == "jin_yong:user_status"
          ) {
            arr2.push(item);
          }
        });
        this.StatusValList = arr2;
      });
    },

    // 新建版本
    addServe() {
      this.isShowDialog = true;
      this.dialogTitle = "新建账号";
      this.dialogType = "add";
      this.getEmployee();
      this.getRoleList();
      this.getStatusValLists();
    },
    // 编辑
    editorServe(userId) {
      this.$API.wtl_getAccountDetail({ userId: userId }).then((res) => {
        this.isShowDialog = true;
        this.dialogTitle = "编辑账号";
        this.dialogType = "edit";
        let datas = res.data.result || {};
        this.dialogForm = datas;
        let ids = datas.roleInfos || [];

        let roleIds = [];
        ids.forEach((item) => {
          roleIds.push(item.roleId + "");
        });

        if (datas.objectVos && datas.objectVos.length > 0) {
          // this.dialogForm.objectVos = datas.objectVos;

          datas.objectVos.forEach((item, idx) => {
            item.userType = item.userType;
            item.UserName = item.documentName;
            item.documentId = item.documentId + "";
            item.operationType = "UPDATE";

            this.getAccountObjectDownList(item.userType, "", idx);
          });

          this.objectVos_a = JSON.parse(JSON.stringify(datas.objectVos));
          this.dialogForm.objectVos = datas.objectVos;
        } else {
          datas.objectVos = [];
          datas.objectVos.push({
            documentId: "",
            UserName: "",
            CustomerLists: [],
            operationType: "ADD",
          });

          this.dialogForm.objectVos = datas.objectVos;
        }

        this.dialogForm.roleIds = roleIds || [];

        this.getEmployee(); //res.data.employeeName
        this.getRoleList(res.data.username);
        this.getStatusValLists();
      });
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },

    //=>选择表格操作
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //表格样式i
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
    },
    /**
     * ******************************计算表格高度**开始*************************
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    //分页
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
    // 获取数据
    getData() {
      let that = this;
      let param = {
        deptId: this.queryData.deptId,
        name: this.queryData.name,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
      };
      this.$API.wtl_getAccountList(param).then((res) => {
        that.className = res.data.result.className || "";
        that.tableData = res.data.result.data || [];
        that.pageCount = res.data.result.pageCount || 0;
        this.$nextTick(() => {
          this.fetTableHeight();
        });
      });
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        userStatus: "zheng_chang:user_status",
        bindMail: "",
        deptId: "",
        seeRangeDeptIds: [],
        manageRangedeptIds: [],
        bindPhone: "",
        employeeId: "",
        name: "",
        password: "",
        remarks: "",
        username: "",
        roleIds: [],
        objectVos: [
          {
            documentId: "",
            UserName: "",
            CustomerLists: [],
            operationType: "ADD",
          },
        ],
      };
      this.DELObjsList = [];
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let objectReqs =
            JSON.parse(JSON.stringify(this.dialogForm.objectVos)) || [];
          objectReqs = [...this.DELObjsList, ...objectReqs];
          for (var i = 0; i < objectReqs.length; i++) {
            delete objectReqs[i].UserName;
            if (
              objectReqs[i].operationType == "ADD" &&
              objectReqs[i].documentId == ""
            ) {
              objectReqs.splice(i, 1);
              i--;
            }
          }

          if (this.dialogType == "add") {
            if (
              this.dialogForm.password.length < 6 ||
              this.dialogForm.password.length > 50
            ) {
              this.$message.error("密码格式不正确,请输入 6-50位的密码");
              return false;
            }
          }

          let param = {
            bindMail: this.dialogForm.bindMail || "",
            bindPhone: this.dialogForm.bindPhone || "",
            // employeeId: this.dialogForm.employeeId || "",
            name: this.dialogForm.name || "", //用户名
            password: this.dialogForm.password || "",
            remarks: this.dialogForm.remarks || "",
            roleIds: this.dialogForm.roleIds || [],
            userStatus: this.dialogForm.userStatus || "",
            deptId: this.dialogForm.deptId || "",
            seeRangeDeptIds: this.dialogForm.seeRangeDeptIds || [],
            manageRangedeptIds: this.dialogForm.manageRangedeptIds || [],
            username: this.dialogForm.username || "", //账号
            objectReqs: objectReqs,
          };

          if (this.dialogType == "add") {
            // 新建
            this.$API.wtl_addAccount(param).then((res) => {
              this.$message.success(res.data.message || "新建成功");
              this.getData();
              this.isShowDialog = false;
            });
          } else {
            // 修改
            delete param.password;
            delete param.username;
            param.userId = this.dialogForm.userId || "";

            this.$API.wtl_udpateAccount(param).then((res) => {
              this.$message.success(res.data.message || "修改成功");
              this.getData();
              this.isShowDialog = false;
            });
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        newPasswpord: "",
        userId: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn2() {
      if (
        this.dialogForm2.newPasswpord.length < 6 ||
        this.dialogForm2.newPasswpord.length > 50
      ) {
        this.$message.error("密码格式不正确,请输入 6-50位的密码");
        return false;
      }
      this.$API
        .updatePassword({
          newPasswpord: this.dialogForm2.newPasswpord,
          userId: this.dialogForm2.userId,
        })
        .then((res) => {
          this.$message.success(res.data.message || "修改成功");
        });
      this.isShowDialog2 = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn2() {
      this.isShowDialog2 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // ===================排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },
  },
};
</script>

<style scoped lang="less">
// .containerbox {
//   height: calc(100vh - 75px);
// }

// .tableBox {
//   height: calc(100% - 180px);
// }
.colorStyle {
  color: #f00;
}
.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}
.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}
.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}
.imgbox {
  width: 100%;
  margin-left: 12%;
  box-sizing: border-box;
}
.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
  }
}
.singleinp1 {
  min-width: 392px;
}
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}
.SingleChoicebox {
  width: 100%;
  padding: 0 20px;
  margin-top: 20px;
  box-sizing: border-box;
}
.el-input-number {
  width: 100%;
  height: 30px;
  line-height: 30px;
}
.serverContent {
  .tableBox {
    background-color: #fff;
  }
  .btnList1 {
    width: auto;
    // padding: 10px;
    border-radius: 4px;
  }
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}
</style>
